// Some API members do not auto generate well. We manually define these.
export enum GTSessionType {
  DEFAULT = 'DEFAULT',
  AVATAR_TELEHEALTH = 'AVATAR_TELEHEALTH',
  TELEHEALTH = 'TELEHEALTH'
}